import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";
import { PathDataUtility } from "../utils/PathDataUtility";

export class Coinbase extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("base", _placeholderMode);
    }
    
    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        //this.appendBlendStyle(svg);
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const R = 40;
        const r0 = 100;
        const height = 60, halfH = height / 2;
        const pX = halfH * Math.tan(24 * Math.PI / 180);

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        const color1 = this.getColorHex(1, 2, 3);
        const color2 = this.getColorHex(4, 5, 6);
        const color3 = this.getColorHex(7, 8, 9);
        
        const idOB = `circleOutbounding_${this.chainIdName}`;
        const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
        const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
        obCircle.id = idOB;
        obCircle.setAttribute("d", `${dOB}`);
        defs.appendChild(obCircle);

        const idBaseSign = `sign_${this.chainIdName}`;
        // width="41" height="39" viewBox="0 0 41 39"
        let signData = `M38.3312 57C28.1096 57 19.8306 48.4975 19.8306 38C19.8306 27.5025 28.1096 19 38.3312 19C47.4892 19 55.09 25.8558 56.5546 34.8333H75.194C73.6216 15.3267 57.7263 0 38.3312 0C17.9034 0 1.32983 17.0208 1.32983 38C1.32983 58.9791 17.9034 76 38.3312 76C57.7263 76 73.6216 60.6733 75.194 41.1667H56.5546C55.09 50.1442 47.4892 57 38.3312 57Z`;
        const pathData = PathDataUtility.parsePathDataString(signData);
        const newPathData = PathDataUtility.translate(true, pathData, new Point(0, -r0));
        signData = PathDataUtility.convertToDString(newPathData);
        const baseSign = SvgUtils.createPath(idBaseSign, signData, true, "", "", 0);
        defs.appendChild(baseSign);

        const points: Array<Point> = [ new Point(0, -r0 + halfH),
            new Point(-pX, -r0),
            new Point(0, -r0 - halfH),
            new Point(pX, -r0)
        ];
        const polygonId = `polygon_48deg_120_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        svg.appendChild(defs);

        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        const bigScale = R / 150;
        // big-1
        this.addCircleUseToGroup(group, idBaseSign, null, null, null, ``, color1, "", 0);
        // big-2
        this.addCircleUseToGroup(group, idBaseSign, null, null, null, `rotate(120,0,0)`, color2, "", 0);
        // big-3
        this.addCircleUseToGroup(group, idBaseSign, null, null, null, `rotate(240,0,0)`, color3, "", 0);

        // small-1
        const color4 = this.getColorHex(10, 11, 12);
        this.addUsePartToGroup(group, polygonId, "rotate(60,0,0)", color4, "", 0);
        // // small-2
        const color5 = this.getColorHex(13, 14, 15);
        this.addUsePartToGroup(group, polygonId, "rotate(180,0,0)", color5, "", 0);
        // // small-3
        const color6 = this.getColorHex(16, 17, 18);
        this.addUsePartToGroup(group, polygonId, "rotate(300,0,0)", color6, "", 0);

        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);
        return svg;
    }

}